import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Pencil, Check, LayoutDashboard } from "lucide-react";
import { useSite } from "../../context/SiteContext";

export const AdminBar = () => {
  const { isAdmin, editMode, setEditMode } = useSite();
  const { search } = useLocation();

  useEffect(() => { if (isAdmin && new URLSearchParams(search).get("edit") === "1") setEditMode(true); }, [isAdmin, search, setEditMode]);

  if (!isAdmin) return null;
  return (
    <>
      {editMode && (
        <div className="sticky top-0 z-[60] bg-brand-gold text-brand-ink text-xs sm:text-sm px-4 py-2 text-center font-medium" data-testid="edit-mode-banner">
          Edit mode — click any outlined text to change it, use the buttons on images and videos to replace them. Changes save automatically.
        </div>
      )}
      <div className="fixed bottom-5 left-5 z-[70] flex items-center gap-2 rounded-full bg-brand-ink/95 backdrop-blur px-2 py-2 shadow-2xl" data-testid="admin-bar">
        <button onClick={() => setEditMode(!editMode)} data-testid="toggle-edit-mode"
          className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-colors ${editMode ? "bg-brand-gold text-brand-ink" : "bg-white/10 text-white hover:bg-white/20"}`}>
          {editMode ? <><Check size={15} /> Done Editing</> : <><Pencil size={15} /> Edit This Page</>}
        </button>
        <Link to="/admin" className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm text-white/85 hover:text-white hover:bg-white/10 transition-colors" data-testid="admin-bar-panel">
          <LayoutDashboard size={15} /> Admin
        </Link>
      </div>
    </>
  );
};
